import { Modal } from 'components';
import { FC } from 'react';

import { ConfirmDeleteContentStyled } from './styles';

interface Props {
  onOk: () => void;
  onCancel: () => void;
  visible: boolean;
}

const ModalConfirmDelete: FC<Props> = ({ onOk, onCancel, visible }) => (
  <Modal
    title="この項目を削除します。よろしいですか？"
    visible={visible}
    width={640}
    okButton={{
      text: '削除',
      onClick: onOk,
    }}
    cancelButton={{
      text: 'キャンセル',
      onClick: onCancel,
    }}
  >
    <ConfirmDeleteContentStyled>この操作は元に戻せません</ConfirmDeleteContentStyled>
  </Modal>
);

export default ModalConfirmDelete;
